import { gql } from '@apollo/client';
import fetch from '../core/fetch';
import { change } from 'redux-form';

import {
    PROFILE_PICTURE_LOADER_START,
    UPLOAD_PROFILE_PICTURE_START,
    UPLOAD_PROFILE_PICTURE_SUCCESS,
    UPLOAD_PROFILE_PICTURE_ERROR,
    REMOVE_PROFILE_PICTURE_START,
    REMOVE_PROFILE_PICTURE_SUCCESS,
    REMOVE_PROFILE_PICTURE_ERROR
} from '../constants';

import { loadAccount } from './account';
import { user_Account, UploadProfilePicture, RemoveProfilePicture } from '../lib/graphql/user';
import { demoRestriction, userRestriction } from '../helpers/DemoRestriction/demoRestriction';
import showToaster from '../helpers/toasterMessages/showToaster';

// To Refresh the verification status

export function startProfilePhotoLoader() {
    return (dispatch, getState, { client }) => {
        dispatch({
            type: PROFILE_PICTURE_LOADER_START,
            payload: {
                profilePhotoLoading: true
            }
        });
    };
}

export function stopProfilePhotoLoader() {
    return (dispatch, getState, { client }) => {
        dispatch({
            type: REMOVE_PROFILE_PICTURE_SUCCESS,
            payload: {
                profilePhotoLoading: false
            }
        });
    };
}

export function doUploadProfilePicture(picture, oldPicture, userId) {

    return async (dispatch, getState, { client }) => {

        dispatch({
            type: UPLOAD_PROFILE_PICTURE_START
        });

        try {

            if (oldPicture != null) {
                await removeProfilePhoto(oldPicture);
            }

            const { data } = await client.mutate({
                mutation: UploadProfilePicture,
                variables: {
                    picture,
                    userId
                },
                refetchQueries: [{ query: user_Account }]
            });

            if (data.UploadProfilePicture.status === "success") {
                dispatch({
                    type: UPLOAD_PROFILE_PICTURE_SUCCESS,
                    payload: {
                        profilePhotoLoading: false
                    }
                });
                userId ? await dispatch(change('EditProfileInfo', 'picture', picture)) : dispatch(loadAccount());
            } else {
                dispatch({
                    type: UPLOAD_PROFILE_PICTURE_ERROR,
                    payload: {
                        status,
                        profilePhotoLoading: false
                    }
                });
            }
        } catch (error) {
            dispatch({
                type: UPLOAD_PROFILE_PICTURE_ERROR,
                payload: {
                    error,
                    profilePhotoLoading: false
                }
            });
        }
    };
}


export function doRemoveProfilePicture(fileName, userId, isAdmin) {

    return async (dispatch, getState, { client }) => {

        if (isAdmin) {
            const isRestrict = await dispatch(demoRestriction({}));
            if (isRestrict) return;
        } else {
            const profileId = getState()?.account?.data?.profileId;
            const isRestrict = await dispatch(userRestriction({ restrictType: 'profile', restrictValue: profileId }));
            if (isRestrict) {
                showToaster({ messageId: 'demoWarning', toasterType: 'warning' });
                return;
            }
        }

        dispatch({ type: REMOVE_PROFILE_PICTURE_START });
        dispatch(startProfilePhotoLoader());

        try {

            const { data } = await client.mutate({
                mutation: RemoveProfilePicture,
                variables: { userId },
                refetchQueries: [{ query: user_Account }]
            });

            if (data.RemoveProfilePicture.status === "success") {
                dispatch({
                    type: REMOVE_PROFILE_PICTURE_SUCCESS,
                    payload: {
                        profilePhotoLoading: false
                    }
                });
                userId ? await dispatch(change('EditProfileInfo', 'picture', null)) : dispatch(loadAccount());
                await removeProfilePhoto(fileName);
            } else {
                dispatch({
                    type: REMOVE_PROFILE_PICTURE_ERROR,
                    payload: {
                        status: data.RemoveProfilePicture.status,
                        profilePhotoLoading: false
                    }
                });
            }

        } catch (error) {
            dispatch({
                type: REMOVE_PROFILE_PICTURE_ERROR,
                payload: {
                    error,
                    profilePhotoLoading: false
                }
            });
        }
    };
}


async function removeProfilePhoto(fileName) {
    try {
        const resp = await fetch('/deleteProfilePicture', {
            method: 'post',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ fileName }),
            credentials: 'include'
        });

        const { status } = await resp.json();

        if (status) {
            console.log('status from remove logo file', status);
        }

    } catch (error) {
        console.log('error from remove file', error);

        return false;
    }

    return true;
}
